export class PerceptualHistogram {
    binCount;
    bins;
    constructor(binCount, bins) {
        this.binCount = binCount;
        if (!Number.isInteger(binCount) || binCount < 2)
            throw new Error('Histogram bin count must be at least 2.');
        this.bins = Array.from({ length: binCount }, (_, index) => Math.max(0, bins?.[index] ?? 0));
    }
    addNormalized(value, weight = 1) {
        const index = Math.min(this.binCount - 1, Math.max(0, Math.floor(value * this.binCount)));
        this.bins[index] = (this.bins[index] ?? 0) + Math.max(0, weight);
    }
    addCircularDegrees(degrees, weight = 1) {
        const normalized = ((degrees % 360) + 360) % 360 / 360;
        this.addNormalized(normalized, weight);
    }
    normalized() {
        const total = this.bins.reduce((sum, value) => sum + value, 0);
        return total > 0 ? this.bins.map((value) => value / total) : this.bins.map(() => 0);
    }
    similarity(other) {
        if (other.binCount !== this.binCount)
            throw new Error('Histogram bin counts must match.');
        const first = this.normalized();
        const second = other.normalized();
        const distance = first.reduce((sum, value, index) => sum + Math.abs(value - (second[index] ?? 0)), 0) / 2;
        return Math.max(0, Math.min(1, 1 - distance));
    }
    quantile(position) {
        const normalized = this.normalized();
        const target = Math.max(0, Math.min(1, position));
        let cumulative = 0;
        for (let index = 0; index < normalized.length; index++) {
            cumulative += normalized[index] ?? 0;
            if (cumulative >= target)
                return (index + 0.5) / this.binCount;
        }
        return 1;
    }
}
//# sourceMappingURL=PerceptualHistogram.js.map